import { useState, useEffect, useRef } from 'react';

export default function DroneVideo(props) {
    const videoRef = useRef(null);
    const [videoError, setVideoError] = useState(false);
    const [isIOS, setIsIOS] = useState(false);

    const videoSrc = window.innerWidth < 780 ? props.fileNameSmall : props.fileName;

    const { height='', maxWidth='', align='' } = props;

    useEffect(() => {
        const userAgent = navigator.userAgent.toLowerCase();
        const isIOSDevice = /iphone|ipad|ipod/.test(userAgent);
        setIsIOS(isIOSDevice);
    }, []);

    // Ensures the video plays even when browsers have strict autoplay policies
    useEffect(() => {
        if (videoRef.current) {
            const playVideo = async () => {
                try {
                    await videoRef.current.play();
                } catch (error) {
                    console.error("Autoplay was prevented:", error);
                    setVideoError(true);
                }
            };
            playVideo();
        }

        return () => {
            if (videoRef.current) {
                videoRef.current.pause();
            }
        };
    }, []);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const handleVideoEnded = () => {
            video.currentTime = 0;
            video.play().catch((err) => console.error("Loop play error:", err));
        };

        video.addEventListener("ended", handleVideoEnded);

        return () => {
            video.removeEventListener("ended", handleVideoEnded);
        };
    }, [isIOS]);

    const isNumberRegex = (value) => {
        return /^[+-]?\d+(\.\d+)?$/i.test(value.trim())
    }

    return (
        <div className={`grow overflow-hidden w-full ${align}`}>
            <video
                ref={videoRef}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                onError={() => setVideoError(true)}
                className={`rounded-xl ${maxWidth ? '' : 'w-full'} ${height ? '' : 'h-full'}`}
                style={{objectFit: 'cover', height: isNumberRegex(height) ? height+'px' : height, maxWidth: isNumberRegex(maxWidth) ? maxWidth+'px' : maxWidth}}>

            {!videoError && (
                <source
                src={`${Window.static_path}video/${videoSrc}`}
                type="video/mp4"
                />
            )}
            </video>
        </div>
    )
}
